import React from "react";
import { MessageCircle } from "lucide-react";

// Inline WhatsApp icon (brand-accurate) for CTA emphasis
export const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M19.11 17.21c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.31.2-.58.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.55.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.61-1.46-.83-2-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.47.07-.72.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.63 1.11 2.81.13.18 1.91 2.91 4.62 4.08.65.28 1.15.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.31zM16.02 5.34c-5.85 0-10.6 4.74-10.6 10.59 0 1.87.49 3.69 1.42 5.3L5.4 26.66l5.6-1.46a10.55 10.55 0 0 0 5.02 1.27h.01c5.84 0 10.59-4.74 10.59-10.59 0-2.83-1.1-5.49-3.1-7.49a10.5 10.5 0 0 0-7.5-3.05zm6.18 16.78a8.78 8.78 0 0 1-6.19 2.56h-.01c-1.6 0-3.16-.43-4.52-1.24l-.32-.19-3.32.87.89-3.24-.21-.33a8.79 8.79 0 0 1-1.34-4.66c0-4.86 3.96-8.81 8.82-8.81 2.36 0 4.57.92 6.24 2.59a8.74 8.74 0 0 1 2.58 6.23 8.78 8.78 0 0 1-2.62 6.22z" />
  </svg>
);

const WhatsAppButton = ({
  href,
  children,
  variant = "primary",
  className = "",
  testId,
  fullWidth = false,
}) => {
  const base =
    variant === "primary"
      ? "btn-primary"
      : variant === "ghost"
      ? "btn-ghost"
      : "btn-primary";
  return (
    <a
      data-testid={testId}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} ${fullWidth ? "w-full justify-center" : ""} ${className}`}
    >
      <WhatsAppIcon className="w-[18px] h-[18px]" />
      <span>{children}</span>
    </a>
  );
};

export default WhatsAppButton;
